var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"value",staticClass:"tag-input uneditable-input span12",class:{readonly: _vm.readOnly},attrs:{"tabindex":"0"},on:{"click":function($event){return _vm.click($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }